import React, {useState, useEffect} from 'react'
import {
	Button,
	Card,
	Col,
	Form,
	Input,
	Row,
	Select,
	Typography,
	Upload,
	Radio
} from "antd";

import data from '../../data/rawMaterialData'

const layerObj = {layerId: 0, layerType: "", materialType:"", gsm:"", bf:"", ff:""};

const compactItemStyle = { marginBottom: "10px" };
const compactLabelCol = { flex: '40px' };
const compactWrapperCol = { flex: 'auto' };

const LayerSelectorBasic = (props) => {
	const {layers, layerSelector} = props
	const [topGsm, setTopGsm] = useState([])
	const [topBf, setTopBf] = useState([])
	const [fluteGsm, setFluteGsm] = useState([])
	const [fluteBf, setFluteBf] = useState([])
	const [faceGsm, setFaceGsm] = useState([])
	const [faceBf, setFaceBf] = useState([])

	// Access the parent Form instance so we can sync field values
	const formInstance = Form.useFormInstance();

	// Initialize dropdown options from existing layers data (for edit/update mode)
	useEffect(() => {
		if (layers && layers.length > 0) {
			const formValues = {};
			// Top layer
			if (layers[0]?.materialType && data.materialGsm[layers[0].materialType]) {
				setTopGsm(data.materialGsm[layers[0].materialType]);
				setTopBf(data.materialBf[layers[0].materialType] || []);
				formValues.materialType = layers[0].materialType;
				if (layers[0].gsm) formValues.top_gsm = layers[0].gsm;
				if (layers[0].bf) formValues['top-bf'] = layers[0].bf;
			}
			// Flute layer
			if (layers[1]?.materialType && data.materialGsm[layers[1].materialType]) {
				setFluteGsm(data.materialGsm[layers[1].materialType]);
				setFluteBf(data.materialBf[layers[1].materialType] || []);
				formValues.flute_materialType = layers[1].materialType;
				if (layers[1].gsm) formValues.flute_gsm = layers[1].gsm;
				if (layers[1].bf) formValues.flute_bf = layers[1].bf;
				if (layers[1].ff) formValues.flute_ff = layers[1].ff;
			}
			// Face/Bottom layer
			if (layers[2]?.materialType && data.materialGsm[layers[2].materialType]) {
				setFaceGsm(data.materialGsm[layers[2].materialType]);
				setFaceBf(data.materialBf[layers[2].materialType] || []);
				formValues.face_materialType = layers[2].materialType;
				if (layers[2].gsm) formValues.face_gsm = layers[2].gsm;
				if (layers[2].bf) formValues.face_bf = layers[2].bf;
			}

			// Sync form field values so Selects reflect preserved layer data
			if (formInstance && Object.keys(formValues).length > 0) {
				formInstance.setFieldsValue(formValues);
			}
		}
	}, [layers]);

	const handleLayerChange = (layertype, field, val) => {
		const layersArray = layers.map(l => ({...l}))
		if(layertype === 'top'){
			layersArray[0][field] = val
			setTopGsm(data.materialGsm[layersArray[0].materialType] || [])
			setTopBf(data.materialBf[layersArray[0].materialType] || [])
		}else if(layertype === 'flute'){
			for(let i=1; i< layersArray.length; i+=2){
				layersArray[i][field] = val
			}
			setFluteGsm(data.materialGsm[layersArray[1].materialType] || [])
			setFluteBf(data.materialBf[layersArray[1].materialType] || [])
		}else {
			for(let i=0; i< layersArray.length; i+=2){
				if(i!=0)
				layersArray[i][field] = val
			}
			setFaceGsm(data.materialGsm[layersArray[2].materialType] || [])
			setFaceBf(data.materialBf[layersArray[2].materialType] || [])
		}
		
		props.setLayers([...layersArray])
		console.log("Layers Array:", layersArray)
		
	}
  return (
    <>
	{
		!layerSelector ?
        <Card>
            {/* TOP LAYER */}
            <div style={{ fontWeight: 600, marginBottom: 4 }}>Top Layer:</div>
            <Row gutter={12}>
                <Col xs={8} md={8}>
                <Form.Item
					style={compactItemStyle}
					name='materialType'
					label='Type'
					labelCol={compactLabelCol}
					wrapperCol={compactWrapperCol}
					rules={[{ required: true, message: "Select type!" }]}>
					<Select
						name='top_materialType'
						loading={!data}
						showSearch
						placeholder='Type'
						optionFilterProp='children'
						filterOption={(input, option) =>
							option.children.includes(input)
						}
						filterSort={(optionA, optionB) =>
							optionA.children
								.toLowerCase()
								.localeCompare(optionB.children.toLowerCase())
						}
						onChange={(val) => handleLayerChange('top', 'materialType', val)}
					>
						{data &&
							data.materialType.map((type,i) => (
								<Select.Option key={i+1} value={type}>
									{type}
								</Select.Option>
							))}
					</Select>
				</Form.Item>
                </Col>

                <Col xs={8} md={8}>
                <Form.Item
					style={compactItemStyle}
					name='top_gsm'
					label='Gsm'
					labelCol={compactLabelCol}
					wrapperCol={compactWrapperCol}
					rules={[{ required: true, message: "Select GSM!" }]}>
					<Select
						name='material_gsm'
						loading={!data}
						showSearch
						placeholder='GSM'
						optionFilterProp='children'
						filterOption={(input, option) =>
							option.children.includes(input)
						}
						onChange={(val) => handleLayerChange('top', 'gsm', val)}
						>
						{ topGsm.map((gsm,i) => (
								<Select.Option key={i+1} value={gsm}>
									{gsm}
								</Select.Option>
							))
						}
					</Select>
				</Form.Item>
                </Col>

                <Col xs={8} md={8}>
                <Form.Item
					style={compactItemStyle}
					name='top-bf'
					label='Bf'
					labelCol={compactLabelCol}
					wrapperCol={compactWrapperCol}
					rules={[{ required: true, message: "Select BF!" }]}>
					<Select
						name='top-bf'
						loading={!data}
						showSearch
						placeholder='BF'
						optionFilterProp='children'
						filterOption={(input, option) =>
							option.children.includes(input)
						}
						onChange={(val) => handleLayerChange('top', 'bf', val)}
						>
						{topBf.map((bf, i) => (
								<Select.Option key={i+1} value={bf}>
									{bf}
								</Select.Option>
							))}
					</Select>
				</Form.Item>
                </Col>
            </Row>

            {/* FLUTE LAYER */}
            <div style={{ fontWeight: 600, marginBottom: 4 }}>Flute Layer:</div>
            <Row gutter={12}>
                <Col xs={6} md={6}>
                <Form.Item
					style={compactItemStyle}
					name='flute_materialType'
					label='Type'
					labelCol={compactLabelCol}
					wrapperCol={compactWrapperCol}
					rules={[{ required: true, message: "Select type!" }]}>
					<Select
						name='flute_materialType'
						loading={!data}
						showSearch
						placeholder='Type'
						optionFilterProp='children'
						filterOption={(input, option) =>
							option.children.includes(input)
						}
						filterSort={(optionA, optionB) =>
							optionA.children
								.toLowerCase()
								.localeCompare(optionB.children.toLowerCase())
						}
						onChange={(val) => handleLayerChange('flute', 'materialType', val)}
					>
						{data &&
							data.materialType.map((type,i) => (
								<Select.Option key={i+1} value={type}>
									{type}
								</Select.Option>
							))}
					</Select>
				</Form.Item>
                </Col>

                <Col xs={6} md={6}>
                <Form.Item
					style={compactItemStyle}
					name='flute_gsm'
					label='Gsm'
					labelCol={compactLabelCol}
					wrapperCol={compactWrapperCol}
					rules={[{ required: true, message: "Select GSM!" }]}>
					<Select
						name='flute_gsm'
						loading={!data}
						showSearch
						placeholder='GSM'
						optionFilterProp='children'
						filterOption={(input, option) =>
							option.children.includes(input)
						}
						onChange={(val) => handleLayerChange('flute', 'gsm', val)}
						>
						{ fluteGsm.map((gsm,i) => (
								<Select.Option key={i+1} value={gsm}>
									{gsm}
								</Select.Option>
							))
						}
					</Select>
				</Form.Item>
                </Col>

                <Col xs={6} md={6}>
                <Form.Item
					style={compactItemStyle}
					name='flute_bf'
					label='Bf'
					labelCol={compactLabelCol}
					wrapperCol={compactWrapperCol}
					rules={[{ required: true, message: "Select BF!" }]}>
					<Select
						name='flue_bf'
						loading={!data}
						showSearch
						placeholder='BF'
						optionFilterProp='children'
						filterOption={(input, option) =>
							option.children.includes(input)
						}
						onChange={(val) => handleLayerChange('flute', 'bf', val)}
						>
						{ fluteBf.map((bf,i) => (
								<Select.Option key={i+1} value={bf}>
									{bf}
								</Select.Option>
							))
						}
					</Select>
				</Form.Item>
                </Col>

                <Col xs={6} md={6}>
                <Form.Item
					style={compactItemStyle}
					name='flute_ff'
					label='Ff'
					labelCol={compactLabelCol}
					wrapperCol={compactWrapperCol}
					rules={[{ required: true, message: "Select FF!" }]}>
					<Select
						name='flute_ff'
						loading={!data}
						showSearch
						placeholder='FF'
						optionFilterProp='children'
						filterOption={(input, option) =>
							option.children.includes(input)
						}
						onChange={(val) => handleLayerChange('flute', 'ff', val)}
						>
						{data &&
							data.ff.map((ff, i) => (
								<Select.Option key={i+1} value={ff}>
									{ff}
								</Select.Option>
							))}
					</Select>
				</Form.Item>
                </Col>
            </Row>

            {/* FACE LAYER */}
            <div style={{ fontWeight: 600, marginBottom: 4 }}>Face Layer:</div>
            <Row gutter={12}>
                <Col xs={8} md={8}>
                <Form.Item
					style={compactItemStyle}
					name='face_materialType'
					label='Type'
					labelCol={compactLabelCol}
					wrapperCol={compactWrapperCol}
					rules={[{ required: true, message: "Select type!" }]}>
					<Select
						name='face_materialType'
						loading={!data}
						showSearch
						placeholder='Type'
						optionFilterProp='children'
						filterOption={(input, option) =>
							option.children.includes(input)
						}
						onChange={(val) => handleLayerChange('face', 'materialType', val)}
						>
						{data &&
							data.materialType.map((type,i) => (
								<Select.Option key={i+1} value={type}>
									{type}
								</Select.Option>
							))}
					</Select>
				</Form.Item>
                </Col>

                <Col xs={8} md={8}>
                <Form.Item
					style={compactItemStyle}
					name='face_gsm'
					label='Gsm'
					labelCol={compactLabelCol}
					wrapperCol={compactWrapperCol}
					rules={[{ required: true, message: "Select GSM!" }]}>
					<Select
						name='face_gsm'
						loading={!data}
						showSearch
						placeholder='GSM'
						optionFilterProp='children'
						filterOption={(input, option) =>
							option.children.includes(input)
						}
						onChange={(val) => handleLayerChange('face', 'gsm', val)}
						>
						{ faceGsm.map((gsm,i) => (
								<Select.Option key={i+1} value={gsm}>
									{gsm}
								</Select.Option>
							))
						}
					</Select>
				</Form.Item>
                </Col>

                <Col xs={8} md={8}>
                <Form.Item
					style={compactItemStyle}
					name='face_bf'
					label='Bf'
					labelCol={compactLabelCol}
					wrapperCol={compactWrapperCol}
					rules={[{ required: true, message: "Select BF!" }]}>
					<Select
						name='face_bf'
						loading={!data}
						showSearch
						placeholder='BF'
						optionFilterProp='children'
						filterOption={(input, option) =>
							option.children.includes(input)
						}
						onChange={(val) => handleLayerChange('face', 'bf', val)}
						>
						{faceBf.map((bf,i) => (
								<Select.Option key={i+1} value={bf}>
									{bf}
								</Select.Option>
							))
						}
					</Select>
				</Form.Item>
                </Col>
            </Row>
        </Card>
		: <></>
	}
    </>
  )
}

export default LayerSelectorBasic